define('views/modules/template/assignment/manager/per-user/per-user-manager-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/panel/base-panel',
    'views/modules/template/assignment/manager/per-user/per-user-manager-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VPerUserAssignmentManagerContent
) {

    var VPerUserAssignmentManagerPanel = VBasePanel.extend({
        content: {
            manager: VPerUserAssignmentManagerContent,
        },

        header: {
            title: "Assignments manager",
            subtitle: "Template assigments by user",
        },

        tabs: [{ id: 'manager', title: 'Manager', active: true }],
        defaultView: 'manager',

        initialize: function(opt) {
            var manager = this.getView('manager',
                _.pick(opt, ['profile', 'group', 'collection', 'url'])
            );
        },

    });

    return VPerUserAssignmentManagerPanel;

});

